import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { Shipment } from '../../core/api/lab.types';

export const listShipmentsHasErrorSelector = (state: RootState): any =>
  state.listShipments.errors && state.listShipments.errors ? true : false;

export const listShipmentsIsBusySelector = (state: RootState): boolean =>
  state.listShipments.status === StoreStatus.BUSY;

export const listShipmentsResponseSelector = (state: RootState): Shipment[] | null =>
  state.listShipments.response || null;
